import React from 'react';
import styles from './ShipChartCard.module.scss';

type Legend = {
  color: string;
  text: string;
};
interface ShipChartCardProps {
  title: string;
  legend: string;
  chart: React.ReactNode;
  shipImage: string;
  chartWidth?: string;
  chartHeight?: string;
  imgWidth?: string;
  imgHeight?: string;
  cardHeight?: string;
  legend1?: Legend;
  legend2?: Legend;
}

const ShipChartCard: React.FC<ShipChartCardProps> = ({
  title,
  legend,
  chart,
  shipImage,
  chartHeight,
  chartWidth,
  imgHeight,
  imgWidth,
  cardHeight,
  legend1,
  legend2,
}) => {
  return (
    <div style={{ height: cardHeight }} className={styles.card}>
      <div className="flex flex-row justify-content-between align-items-center w-100 ">
        <div className="md:col-8 col-12">
          <div className={styles.header}>
            <div className={styles.titleAndLegend}>
              <h2 className={styles.title}>{title}</h2>
              <span className={styles.legend}>{legend}</span>
            </div>
            <div className={styles.legendContainer}>
              <div className={styles.legendItem}>
                <span
                  className={styles.circle}
                  style={{ backgroundColor: legend1?.color }}
                />
                <span className={styles.legendText}>{legend1?.text}</span>
              </div>
              <div className={styles.legendItem}>
                <span
                  className={styles.circle}
                  style={{ backgroundColor: legend2?.color }}
                />
                <span className={styles.legendText}>{legend2?.text}</span>
              </div>
            </div>
          </div>
          <div className={styles.images}>
            <div
              style={{ width: chartWidth, height: chartHeight }}
              className={styles.chartImage}
            >
              {chart}{' '}
            </div>
          </div>
        </div>
        <div className="md:col-4 col-12 flex justify-content-center">
          <img
            style={{ width: imgWidth, height: imgHeight }}
            className={styles.shipImage}
            src={shipImage}
            alt="ship-icon"
          />
        </div>
      </div>
    </div>
  );
};

export default ShipChartCard;
